/**
 * Custom error for authentication initialization failures
 * Provides user-friendly error messages based on error type
 */
export class AuthInitializationError extends Error {
  public readonly originalError: unknown;
  public readonly errorType: 'network' | 'server' | 'configuration' | 'unknown';

  constructor(
    message: string,
    originalError: unknown,
    errorType: 'network' | 'server' | 'configuration' | 'unknown'
  ) {
    super(message);
    this.name = 'AuthInitializationError';
    this.originalError = originalError;
    this.errorType = errorType;
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, AuthInitializationError);
    }
  }
}
